import P from "lodash/isDate";
import U from "lodash/isNumber";
import I from "lodash/isString";
import j from "lodash/clamp";
import Z from "lodash/isPlainObject";
import { parse as B, format as R } from "./fecha.js";
const q = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
class V {
  constructor({ id: t, firstDayOfWeek: e, masks: s }) {
    this.id = t, this.firstDayOfWeek = j(e, 1, 7), this.masks = s, this.dayNames = this.getDayNames("long"), this.dayNamesShort = this.getDayNames("short"), this.dayNamesShorter = this.dayNamesShort.map((o) => o.substring(0, 2)), this.dayNamesNarrow = this.getDayNames("narrow"), this.monthNames = this.getMonthNames("long"), this.monthNamesShort = this.getMonthNames("short"), this.monthData = {}, this.getMonthComps = this.getMonthComps.bind(this), this.parse = this.parse.bind(this), this.format = this.format.bind(this), this.toDate = this.toDate.bind(this);
  }
  parse(t, e) {
    return B(t, e || this.masks.L, this);
  }
  format(t, e) {
    return R(t, e || this.masks.L, this);
  }
  toDate(t, e) {
    if (P(t))
      return new Date(t.getTime());
    if (U(t))
      return new Date(t);
    if (I(t))
      return this.parse(t, e);
    if (Z(t)) {
      const s = /* @__PURE__ */ new Date();
      return new Date(t.year || s.getFullYear(), t.month || s.getMonth(), t.day || s.getDate());
    }
    return t;
  }
  getMonthDates(t = 2e3) {
    const e = [];
    for (let s = 0; s < 12; s++)
      e.push(new Date(t, s, 15));
    return e;
  }
  getMonthNames(t) {
    const e = new Intl.DateTimeFormat(this.id, {
      month: t,
      timeZone: "UTC"
    });
    return this.getMonthDates().map((s) => e.format(s));
  }
  getWeekdayDates({ year: t = 2e3, utc: e = !1, firstDayOfWeek: s = this.firstDayOfWeek } = {}) {
    const o = [];
    for (let a = 1, r = 0; r < 7; a++) {
      const i = e ? new Date(Date.UTC(t, 0, a)) : new Date(t, 0, a);
      ((e ? i.getUTCDay() : i.getDay()) === s - 1 || r > 0) && (o.push(i), r++);
    }
    return o;
  }
  getDayNames(t) {
    const e = new Intl.DateTimeFormat(this.id, {
      weekday: t,
      timeZone: "UTC"
    });
    return this.getWeekdayDates({ firstDayOfWeek: 1, utc: !0 }).map((s) => e.format(s));
  }
  // Days/month/year components for a given month and year
  getMonthComps(t, e) {
    const s = `${t}-${e}`;
    let o = this.monthData[s];
    if (!o) {
      const a = e % 4 === 0 && e % 100 !== 0 || e % 400 === 0, r = new Date(e, t - 1, 1).getDay() + 1, i = t === 2 && a ? 29 : q[t - 1], m = Math.ceil((i + Math.abs(r - this.firstDayOfWeek)) / 7);
      o = {
        firstDayOfWeek: this.firstDayOfWeek,
        inLeapYear: a,
        firstWeekday: r,
        days: i,
        weeks: m,
        month: t,
        year: e
      }, this.monthData[s] = o;
    }
    return o;
  }
  // Days/month/year components for today's month
  getThisMonthComps() {
    const t = /* @__PURE__ */ new Date();
    return this.getMonthComps(t.getMonth() + 1, t.getFullYear());
  }
  // Day/month/year components for previous month
  getPrevMonthComps(t, e) {
    return t === 1 ? this.getMonthComps(12, e - 1) : this.getMonthComps(t - 1, e);
  }
  // Day/month/year components for next month
  getNextMonthComps(t, e) {
    return t === 12 ? this.getMonthComps(1, e + 1) : this.getMonthComps(t + 1, e);
  }
  getDayFromDate(t) {
    if (!t)
      return null;
    const e = t.getMonth() + 1, s = t.getUTCFullYear(), o = this.getMonthComps(e, s), a = t.getDate(), r = o.days - a + 1, i = t.getDay() + 1, m = Math.floor((a - 1) / 7 + 1), d = Math.floor((o.days - a) / 7 + 1), h = Math.ceil((a + Math.abs(o.firstWeekday - o.firstDayOfWeek)) / 7), l = o.weeks - h + 1;
    return {
      day: a,
      dayFromEnd: r,
      weekday: i,
      weekdayOrdinal: m,
      weekdayOrdinalFromEnd: d,
      week: h,
      weekFromEnd: l,
      month: e,
      year: s,
      date: t,
      dateTime: t.getTime()
    };
  }
  // Buils day components for a given page
  getCalendarDays(t) {
    const e = [], { monthComps: s, prevMonthComps: o, nextMonthComps: a } = t, { firstDayOfWeek: r, firstWeekday: i } = s, m = i + (i < r ? 7 : 0) - r;
    let d = !0, h = !1, l = !1, n = o.days - m + 1, c = o.days - n + 1, D = Math.floor((n - 1) / 7 + 1), g = 1, p = o.weeks, M = 1, { month: y, year: k } = o;
    const C = /* @__PURE__ */ new Date(), v = C.getDate(), x = C.getMonth() + 1, L = C.getFullYear();
    for (let u = 1; u <= 6; u++) {
      for (let f = 1, w = r; f <= 7; f++, w += w === 7 ? -6 : 1) {
        d && w === i && (n = 1, c = s.days, D = Math.floor((n - 1) / 7 + 1), g = Math.floor((s.days - n) / 7 + 1), p = 1, M = s.weeks, y = s.month, k = s.year, d = !1, h = !0);
        const T = new Date(k, y - 1, n), F = f, Y = 7 - f, O = n === v && y === x && k === L, W = h && n === 1, N = h && n === s.days, b = u === 1, $ = u === 6, E = f === 1, S = f === 7;
        e.push({
          id: `${y}-${n}`,
          label: n.toString(),
          day: n,
          dayFromEnd: c,
          weekday: w,
          weekdayPosition: F,
          weekdayPositionFromEnd: Y,
          weekdayOrdinal: D,
          weekdayOrdinalFromEnd: g,
          week: p,
          weekFromEnd: M,
          month: y,
          year: k,
          date: T,
          dateTime: T.getTime(),
          isToday: O,
          isFirstDay: W,
          isLastDay: N,
          inMonth: h,
          inPrevMonth: d,
          inNextMonth: l,
          onTop: b,
          onBottom: $,
          onLeft: E,
          onRight: S,
          classes: [
            `day-${n}`,
            `day-from-end-${c}`,
            `weekday-${w}`,
            `weekday-position-${F}`,
            `weekday-ordinal-${D}`,
            `weekday-ordinal-from-end-${g}`,
            `week-${p}`,
            `week-from-end-${M}`,
            {
              "is-today": O,
              "is-first-day": W,
              "is-last-day": N,
              "in-month": h,
              "in-prev-month": d,
              "in-next-month": l,
              "on-top": b,
              "on-bottom": $,
              "on-left": E,
              "on-right": S
            }
          ],
          attribute: null
        }), h && N ? (h = !1, l = !0, n = 1, c = a.days, D = 1, g = Math.floor((a.days - n) / 7 + 1), p = 1, M = a.weeks, y = a.month, k = a.year) : (n++, c--, D = Math.floor((n - 1) / 7 + 1), g = Math.floor((s.days - n) / 7 + 1));
      }
      p++, M--;
    }
    return e;
  }
}
export {
  V as default
};
//# sourceMappingURL=locale.js.map
